/**
 * User height based on median value during menu clicks.
 */
AFRAME.registerComponent('player-height', {
  init: function () {
    this.beatOffset = 0;
    this.heights = [];
    this.height = 0;
    this.el.sceneEl.addEventListener('menuchallengeselect', this.updateHeight.bind(this));
    this.el.sceneEl.addEventListener('playbuttonclick', this.updateHeight.bind(this));
  },

  pause: function () {
    this.heights.length = 0;
  },

  updateHeight: function () {
    const heights = this.heights;
    if (heights.length > 3) { heights.shift(); }
    heights.push(this.el.object3D.position.y);
    this.height = median(heights);

    // Adjust beat container height.
    const height = clamp(this.height, 1.6, 2.2);
    this.beatOffset = remap(height, 1.6, 2.2, 0, 0.2);
  }
});

function median (arr) {
  arr.sort(sort);
  const mid = arr.length / 2;
  return mid % 1 ? arr[mid - 0.5] : (arr[mid - 1] + arr[mid]) / 2;
}

function sort (a, b) {
  return a - b;
}

function remap (value, low1, high1, low2, high2) {
  return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
}

function clamp (val, min, max) {
  return Math.min(Math.max(val, min), max);
}
if (module.hot && window.AFRAME) {
  const componentNames = ['player-height',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
